'use client';

import { PropsWithChildren } from 'react';
import { ReCaptchaProvider } from 'next-recaptcha-v3';

import BackToTopButton from '@/components/BackToTopButton/BackToTopButton';
import NewsletterModalContextProvider from '@/context/newsletter-modal.context';
import NavbarDrawer from '@/features/Header/components/Navbar/NavbarDrawer/NavbarDrawer';
import { navItem } from '@/features/Header/constants';
import ClientOnly from '@/helpers/ClientOnly';
import { Modals } from '@/modals/Modals';

function Providers<T>({ children }: PropsWithChildren<T>) {
  return (
    <ReCaptchaProvider
      language="en"
      useEnterprise={true}
      reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
    >
      <NewsletterModalContextProvider>
        <ClientOnly>
          <NavbarDrawer items={navItem}>{children}</NavbarDrawer>
          <BackToTopButton />
        </ClientOnly>

        <Modals />
      </NewsletterModalContextProvider>
    </ReCaptchaProvider>
  );
}

export default Providers;
